export default __webpack_public_path__ + "static/media/Amazon-RDS.6c4f1eba.svg";